import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";

import "react-reflex/styles.css";

import layoutConf from "../../config/layoutConf";

import Tenant from "./Tenant";
import TenantNamespace from "./TenantNamespace";


function TenantTranslation ( props ) {

    const { t } = useTranslation();

    const [ height, setHeight ] = useState ( 0 );
    const [ tenant, setTenant ] = useState();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    const onSelectTenant = ( tenant ) => {

        setTenant ( tenant );

    };


    return (

        <div style={{ height: height }}>

            <ReflexContainer orientation="vertical">

                <ReflexElement>

                    <Tenant headerTitle={t("term.tenant")} noCreate noEdit noDelete noExcel onSelect={onSelectTenant} />

                </ReflexElement>

                <ReflexSplitter
                    style={{ width: layoutConf.reflex.splitterWidth }}
                />

                <ReflexElement>

                    <TenantNamespace tenant={tenant} />

                </ReflexElement>

            </ReflexContainer>

        </div>

    )

}

export default TenantTranslation;
